export enum PrivilegeLevel {
  MedcardEditOnlyUser = "1",
  MedcardEditWithBranch = "2",
  MedcardEditAll = "3"
}
